import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@linaria/react';
import { COLORS, typographyStyles, Pill } from '@livecommerce/design-system';
import { useLocalization } from 'contexts/LocalizationContext.jsx';

const { getBodyText } = typographyStyles;

const NavigationContainer = styled.ul`
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  margin: 0;
  max-height: 548px;
  grid-area: 1 / 1 / 2 / 2;

  > li {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const NavigationButton = styled.button`
  width: 100%;
  text-align: left;
  background-color: ${(props) => (props.selected ? COLORS.greyMediumLight : 'transparent')};
  border: 0;
  border-radius: 6px;
  ${getBodyText(14)};
  padding: 12px 24px 12px 12px;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  
  &:hover {
    background-color: ${(props) => (props.selected ? COLORS.greyMediumLight : COLORS.greyLight)};
  }
`;

const NavBar = ({ items, selectedItem, setSelectedItem, ...props }) => {
  const { t } = useLocalization();
  const handleClick = (id) => {
    setSelectedItem(id);
  };

  return (
    <NavigationContainer {...props}>
      {items.map(({ id, title, isBeta = false }) => (
        <li key={id}>
          <NavigationButton
            role="tab"
            aria-selected={selectedItem === id}
            aria-controls={id}
            selected={selectedItem === id}
            onClick={() => handleClick(id)}
          >
            {title}
            {isBeta && (
              <Pill backgroundColor={COLORS.orange_500} color={COLORS.light_100}>
                {t('genericLabels.beta')}
              </Pill>
            )}
          </NavigationButton>
        </li>
      ))}
    </NavigationContainer>
  );
};

NavBar.propTypes = {
  items: PropTypes.array,
  selectedItem: PropTypes.string,
  setSelectedItem: PropTypes.func,
};

export default NavBar;
